<template>
    <ModeSwitcher
        ref="modeSwitcher"
        :main-mode-text="$t('create')"
        :create-mode-text="$t('product.info.create_insurance_service')"
        :edit-mode-text="$t('product.info.edit_insurance_service')"
        @reset="editableServiceId = null"
    >
        <template v-slot:btn-block>
            <div class="full-width d-flex align-center">
                <v-spacer />
                <FilterStatusToggle v-model="activeFilter" />
            </div>
        </template>
        <template v-slot:main-mode>
            <v-data-table
                :headers="useHeaders"
                :items="useFilteredInsurance"
                :items-per-page="-1"
                :items-per-page-options="[-1]"
                :loading="isLoading"
                :items-length="useFilteredInsurance.length"
                :sort-by="[{key: 'name', order: 'asc'}]"
                must-sort
                density="compact"
                color="primary"
                class="elevation-1 table-server"
                data-cy="table"
            >
                <template v-slot:item.name="{item}">
                    <div class="text-link" :data-cy="`service-${item.id}`" @click="switchToEditMode(item.id)">
                        {{ item.name }}
                    </div>
                </template>
                <template v-slot:item.active="{item}">
                    {{ item.active ? $t('active') : $t('inactive') }}
                </template>
            </v-data-table>
        </template>
        <template v-slot:additional-mode>
            <InfoContractInsuranceServiceForm
                :editable-service-id="editableServiceId"
                :contract-id="contractId"
                @save="save()"
                @cancel="modeSwitcher.goToTable()"
            />
        </template>
    </ModeSwitcher>
</template>

<script setup lang="ts">
    import InfoContractInsuranceServiceForm from '~/components/products/information/InfoInsuranceServiceForm.vue'

    const props = defineProps<{
        contractId: number
    }>()

    const isLoading = ref<boolean>(false)
    const insurance = ref<any[]>([])
    const modeSwitcher = ref(null)
    const editableServiceId = ref(null)
    const activeFilter = ref<boolean>(true)

    const app = useNuxtApp()
    const {t} = useI18n()

    onMounted(async () => {
        await loadData()
    })

    async function loadData(): Promise<void> {
        try {
            isLoading.value = true
            const rq = {contractId: props.contractId}
            const {apiOwnInsuranceServices} = await app.$api.ownInsuranceServices.get(rq)
            insurance.value = apiOwnInsuranceServices
        } catch (e) {
            insurance.value = []
        } finally {
            isLoading.value = false
        }
    }

    const save = async (): Promise<void> => {
        await loadData()
        modeSwitcher.value.goToTable()
    }

    const useHeaders = computed(() => {
        return [
            {title: t('name'), value: 'name', minWidth: '120px', sortable: true},
            {title: t('coverage_amount'), value: 'amountCoverage'},
            {title: t('franchise'), value: 'franchice'},
            {title: t('status'), value: 'active', width: '140px', minWidth: '140px'},
        ]
    })

    const switchToEditMode = (id): void => {
        modeSwitcher.value.edit()
        editableServiceId.value = id
    }

    const useFilteredInsurance = computed(() => {
        return insurance.value.filter(({active}) => activeFilter.value === active)
    })
</script>
